import { render, staticRenderFns } from "./CartaDroguista.vue?vue&type=template&id=2d262f31&"
import script from "./CartaDroguista.vue?vue&type=script&lang=js&"
export * from "./CartaDroguista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports